/**
 * Copyright (c) 2026 Spicy Friends Ltd.
 * All rights reserved.
 *
 * This source code is licensed under the proprietary license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { createFileRoute } from '@tanstack/react-router'
import ChatFeaturedChannels from '@web/src/features/chat/chat-featured-channels/chat-featured-channels'
import ChatLayout from '@web/src/features/chat/chat-layout/chat-layout'
import { env } from '@web/src/lib/env.client'
import i18n from '@web/src/lib/intl/i18n'
import { robotsMetaForEnvironment, seo } from '@web/src/lib/seo'

export const Route = createFileRoute('/(auth)/(chat-layout)/chat/')({
  component: ChatIndexPage,
  head: () => {
    const t = i18n.t.bind(i18n)
    return seo({
      title: `${t('Chat')} | ${env.VITE_APP_NAME}`,
      description: t('Chat'),
      robots: robotsMetaForEnvironment({ all: 'noindex,nofollow' }),
      meta: [{ name: 'rating', content: 'adult' }],
    })
  },
})

/**
 * Deliberately an empty state rather than a redirect to the most recent room. Landing
 * straight in a conversation makes the back button ambiguous and marks that room read
 * without the user having chosen to open it. Featured channels below give a live entry
 * point without forcing a room open.
 */
function ChatIndexPage() {
  return (
    <ChatLayout showSidebarOnMobile>
      <div className="flex h-full min-h-0 flex-col overflow-y-auto py-10">
        <ChatFeaturedChannels />
      </div>
    </ChatLayout>
  )
}
